import { Routes } from '@angular/router';
import { LayoutComponent } from '@core/components/layout/layout.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { HomeGuard } from '@core/guards/home.guard';
import { permisoCanMatch } from '@core/guards/permisos.guard';
import { HomeComponent } from '@features/home/pages/home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'Account/MyProfile',
        canActivate: [AuthGuard],
        data: { accion: 'MyProfile' },
        loadComponent: () =>
          import('@features/account/pages/myprofile/myprofile.component').then(
            (m) => m.MyprofileComponent,
          ),
      },
      {
        path: 'Operador/DatosOperador',
        canActivate: [AuthGuard],
        data: { accion: 'DatosOperador' },
        loadComponent: () =>
          import('@features/account/pages/operador/operador.component').then(
            (m) => m.OperadorComponent,
          ),
      },
      {
        path: 'Pedido/BuscadorPedidos',
        canMatch: [permisoCanMatch],
        canActivate: [AuthGuard],
        data: { accion: 'BuscadorPedidos' },
        loadComponent: () =>
          import(
            '@features/pedidos/pages/buscador-pedidos/buscador-pedidos.component'
          ).then((m) => m.BuscadorPedidosComponent),
      },
      {
        path: 'Factura/BuscadorFacturas',
        canMatch: [permisoCanMatch],
        canActivate: [AuthGuard],
        data: { accion: 'BuscadorFacturas' },
        loadComponent: () =>
          import(
            '@features/facturas/pages/buscador-facturas/buscador-facturas.component'
          ).then((m) => m.BuscadorFacturasComponent),
      },
      {
        path: 'Movimiento',
        children: [
          { path: '', redirectTo: 'BuscadorMovimientosCliente', pathMatch: 'full' },
          {
            path: 'BuscadorMovimientosCliente',
            data: { accion: 'BuscadorMovimientosCliente' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/movimientos/pages/buscador-movimientos-entrada/buscador-movimientos-entrada.component'
              ).then((m) => m.BuscadorMovimientosEntradaComponent),
          },
          {
            path: 'BuscadorMovimientosDistribuidor',
            data: { accion: 'BuscadorMovimientosDistribuidor' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/movimientos/pages/buscador-movimientos-salida/buscador-movimientos-salida.component'
              ).then((m) => m.BuscadorMovimientosSalidaComponent),
          },
        ],
      },
      {
        path: 'Reclamacion',
        children: [
          { path: '', redirectTo: 'BuscadorReclamaciones', pathMatch: 'full' },
          {
            path: 'BuscadorReclamaciones',
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            data: { accion: 'BuscadorReclamaciones' },
            loadComponent: () =>
              import(
                '@features/reclamaciones/pages/buscador-reclamaciones/buscador-reclamaciones.component'
              ).then((m) => m.BuscadorReclamacionesComponent),
          },
          {
            path: 'NotificarReclamacion',
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            data: { accion: 'NotificarReclamacion' },
            loadComponent: () =>
              import(
                '@features/reclamaciones/pages/notificar-reclamaciones/notificar-reclamaciones.component'
              ).then((m) => m.NotificarReclamacionesComponent),
          },
          {
            path: 'AutoReclamacionesPedido',
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            data: { accion: 'AutoReclamacionesPedido' },
            loadComponent: () =>
              import(
                '@features/reclamaciones/pages/cuadre-automatico-pedido/cuadre-automatico-pedido.component'
              ).then((m) => m.CuadreAutomaticoPedidoComponent),
          },
          {
            path: 'BuscadorLineasRegistradas',
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            data: { accion: 'BuscadorLineasRegistradas' },
            loadComponent: () =>
              import(
                '@features/reclamaciones/pages/buscador-lineas-no-registradas/buscador-lineas-no-registradas.component'
              ).then((m) => m.BuscadorLineasNoRegistradasComponent),
          },
          {
            path: 'BuscadorIncidencias',
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            data: { accion: 'BuscadorIncidencias' },
            loadComponent: () =>
              import(
                '@features/reclamaciones/pages/buscador-incidencias/buscador-incidencias.component'
              ).then((m) => m.BuscadorIncidenciasComponent),
          },
          {
            path: 'BuscadorIndicadorIncidenciasErrorMercadona',
            data: { accion: 'BuscadorIndicadorIncidenciasErrorMercadona' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/reclamaciones/pages/error-mercadona/error-mercadona.component'
              ).then((m) => m.ErrorMercadonaComponent),
          },
        ],
      },
      {
        path: 'Prevision/NotificarPrevisionSemanal',
        data: { accion: 'NotificarPrevisionSemanal' },
        canMatch: [permisoCanMatch],
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('@features/prevision-semanal/pages/prevision-semanal-wrapper/prevision-semanal-wrapper.component')
            .then(m => m.PrevisionSemanalWrapperComponent),
      },
      {
        path: 'Traspaso',
        children: [
          { path: '', redirectTo: 'NotificarTraspaso', pathMatch: 'full' },
          {
            path: 'NotificarTraspaso',
            data: { accion: 'NotificarTraspaso' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/traspasos/pages/notificar-traspaso/notificar-traspaso.component'
              ).then((m) => m.NotificarTraspasoComponent),
          },
          { // TODO => MIRAR ESTA URL EN EL AREApRIVADA VER QUE HAVER CON LAS RUTAS QUE NO VIENEN EN LOS MODULOS
            path: 'VerAutorizaciones',
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/traspasos/pages/ver-autorizaciones/ver-autorizaciones.component'
              ).then((m) => m.VerAutorizacionesComponent),
          },
          {
            path: 'ImportarTraspasos',
            data: { accion: 'ImportarTraspasos' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/traspasos/pages/importar-traspasos/importar-traspasos.component'
              ).then((m) => m.ImportarTraspasosComponent),
          },
          {
            path: 'BuscadorTraspasos',
            data: { accion: 'BuscadorTraspasos' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/traspasos/pages/buscador-traspasos/buscador-traspasos.component'
              ).then((m) => m.BuscadorTraspasosComponent),
          },
        ],
      },
      {
        path: 'CitaPrevia',
        children: [
          { path: '', redirectTo: 'BuscadorCitasPrevias', pathMatch: 'full' },
          {
            path: 'BuscadorCitasPrevias',
            data: { accion: 'BuscadorCitasPrevias' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/cita-previa/pages/buscador-cita-previa/buscador-cita-previa.component'
              ).then((m) => m.BuscadorCitaPreviaComponent),
          },
          {
            path: 'CitaPrevia',
            data: { accion: 'BuscadorCitasPrevias' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/cita-previa/pages/cita-previa/cita-previa.component'
              ).then((m) => m.CitaPreviaComponent),
          },
        ],
      },
      {
        path: '',
        canActivate: [AuthGuard, HomeGuard],
        component: HomeComponent
      },
      {
        path: 'Documentacion',
        children: [
          { path: '', redirectTo: 'DatosDocumentacion', pathMatch: 'full' },
          {
            path: 'DatosDocumentacion',
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            data: { accion: 'DatosDocumentacion' },
            loadComponent: () =>
              import(
                '@features/documentacion/pages/envases/envases.component'
              ).then((m) => m.EnvasesComponent),
          },
          {
            path: 'DatosCertificados',
            data: { accion: 'DatosCertificados' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/documentacion/pages/certificados/certificados.component'
              ).then((m) => m.CertificadosComponent),
          },
          {
            path: 'SubidaDocumentos',
            data: { accion: 'SubidaDocumentos' },
            canActivate: [AuthGuard],
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/documentacion/pages/subir-documentos-proveedor/subir-documentos-proveedor.component'
              ).then((m) => m.SubirDocumentosProveedorComponent),
          },
          // {
          //   path: 'DatosEmisiones',
          //   data: { accion: 'DatosEmisiones' },
          //   canActivate: [AuthGuard],
          //   canMatch: [permisoCanMatch],
          //   loadComponent: () =>
          //     import(
          //       '@features/documentacion/pages/datos-emisiones/datos-emisiones.component'
          //     ).then((m) => m.DatosEmisionesComponent),
          // },
        ],
      },
      {
        path: 'Ayuda',
        children: [
          { path: '', redirectTo: 'DatosAyuda', pathMatch: 'full' },
          {
            path: 'DatosAyuda',
            data: { accion: 'DatosAyuda' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/ayuda_soporte/pages/ayuda/ayuda.component'
              ).then((m) => m.AyudaComponent),
          },
          {
            path: 'NotificarSoporte',
            data: { accion: 'NotificarSoporte' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/ayuda_soporte/pages/soporte/soporte.component'
              ).then((m) => m.SoporteComponent),
          },
        ],
      },
      {
        path: 'Inventario',
        children: [
          { path: '', redirectTo: 'NotificarInventario', pathMatch: 'full' },
          {
            path: 'NotificarInventario',
            canActivate: [AuthGuard],
            data: { accion: 'NotificarInventario' },
            canMatch: [permisoCanMatch],
            loadComponent: () =>
              import(
                '@features/notificar-inventario/pages/notificar-inventario/notificar-inventario.component'
              ).then((m) => m.NotificarInventarioComponent),
          },
        ],
      },
      {
        path: 'PedidoExtra',
        children: [
          { path: '', redirectTo: 'NotificarPedidoExtra', pathMatch: 'full' },
          {
            path: 'NotificarPedidoExtra',
            data: { accion: 'NotificarPedidoExtra' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/pedido-extra/pages/pedido-extra/pedido-extra.component'
              ).then((m) => m.PedidoExtraComponent),
          },
        ],
      },
      {
        path: 'Stock',
        children: [
          { path: '', redirectTo: 'NotificarStock', pathMatch: 'full' },
          {
            path: 'NotificarStock',
            data: { accion: 'NotificarStock' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/stock-fabricante/pages/stock-fabricante/stock-fabricante.component'
              ).then((m) => m.StockFabricanteComponent),
          },
        ],
      },
      {
        path: 'PedidoFabricante',
        children: [
          { path: '', redirectTo: 'BuscadorPedidosFabricante', pathMatch: 'full' },
          {
            path: 'BuscadorPedidosFabricante',
            data: { accion: 'BuscadorPedidosFabricante' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/pedidos-fabricante/pages/pedidos-fabricante/pedidos-fabricante.component'
              ).then((m) => m.PedidosFabricanteComponent),
          },
        ],
      },
      {
        path: 'Compra',
        children: [
          { path: '', redirectTo: 'BuscadorCompras', pathMatch: 'full' },
          {
            path: 'BuscadorCompras',
            data: { accion: 'BuscadorCompras' },
            canMatch: [permisoCanMatch],
            canActivate: [AuthGuard],
            loadComponent: () =>
              import(
                '@features/compras-fabricante/pages/compras-fabricante/compras-fabricante.component'
              ).then((m) => m.ComprasFabricanteComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        // canActivate: [LoginRedirectGuard],
        loadComponent: () =>
          import('@features/auth/pages/login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      {
        path: 'ForgotPassword',
        // canActivate: [LoginRedirectGuard],
        loadComponent: () =>
          import('@features/auth/pages/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: 'SetNewPassword',
        // canActivate: [LoginRedirectGuard],
        loadComponent: () =>
          import('@features/auth/pages/set-new-password/set-new-password.component').then(
            (m) => m.SetNewPasswordComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
